import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ScheduleGroupTeamFiltersQueryCgResponse,
  ScheduleGroupTeamFiltersQueryVariables,
} from '@common/graphql';

export const SCHEDULE_GROUP_TEAM_FILTERS_QUERY: TypedDocumentNode<
  ScheduleGroupTeamFiltersQueryCgResponse,
  ScheduleGroupTeamFiltersQueryVariables
> = gql`
  query ScheduleGroupTeamFilters($scheduleGroupId: ID!) {
    scheduleGroupTeamFilters: serviceLineTeamFilters(
      serviceLineId: $scheduleGroupId
    ) {
      chargeRole
      chargeRoleTerm
      roles
      skillCoverageEnabled
      units {
        id
        name
      }
    }
  }
`;
